import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  btnStyle: {
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: '10px',
    lineHeight: '14px',
    cursor: ({ clickable }) => (clickable ? 'pointer' : 'auto'),
    borderRadius: '4px',
  },
}));

const CustomButton = ({ id, onClick, label, variant, icon, size, type, disabled, clickable = true }) => {
  const classes = useStyles({ type, clickable });

  return (
    <Button
      id={id}
      className={classes.btnStyle}
      onClick={onClick}
      size={size}
      variant={variant}
      startIcon={icon}
      disabled={disabled}
      color={type}
    >
      <div>{label}</div>
    </Button>
  );
};

// Define PropTypes
CustomButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  icon: PropTypes.element,
  size: PropTypes.string,
  type: PropTypes.string,
};

// Default Props
CustomButton.defaultProps = {
  variant: 'contained',
  icon: null,
  size: 'small',
  type: 'primary',
};

export default React.memo(CustomButton);
